import Vue from 'vue'
import Router from 'vue-router'
import { checkAuth } from '../../src/services/AuthService.js'

//****************************************** authentication part */
const isGuest = (to, from, next) => {
  const userisAuthenticated = checkAuth();

  if (userisAuthenticated) {
    next('/home');
    return;
  }
  next();

};

const isAuthenticated = (to, from, next) => {


  const userisAuthenticated = checkAuth();

  if (!userisAuthenticated) {
    next('/');  //login
    return;
  }
  next();
};

const isLogin = (to, from, next) => {

  const userisAuthenticated = checkAuth();

  if (userisAuthenticated) {
    next('/Dashboard');  //
    return;
  }
  next();
};

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')
const MultiSelectDualListBox = () => import('@/views/notifications/multiSelectDualListBox')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const RegisterUser = () => import('@/views/pages/RegisterUser')
const ForgetPassword = () => import('@/views/pages/ForgetPassword')
const LeafLeft = () => import('@/views/pages/LeafLeft')
const ChangePasswordPage = () => import('@/views/pages/ChangePasswordPage')


// Users - UsersGroup
const Users = () => import('@/views/users/Users')
const OrganizationStructure = () => import('@/views/users/OrganizationStructure')

// const User = () => import('@/views/users/User')

// Rolls
const Roles = () => import('@/views/roles/Roles')

// Maintenance
const BasicServices = () => import('@/views/maintenance/basicServices')
const PeriodicServices = () => import('@/views/maintenance/periodicServices')
const CostPerService = () => import('@/views/maintenance/costPerService')

// Layers
const LayerClassify = () => import('@/views/layer/layerClassify')
const LayerPoint = () => import('@/views/layer/layerPoint')


// Admin
const Admin = () => import('@/views/admin/Admin')

const CarTracking = () => import('@/views/map/carTracking')
const StopLocation = () => import('@/views/map/stopLocation')


// sensor
const OnlineChart = () => import('@/views/sensor/onlineChart')
const SensorSetting = () => import('@/views/sensor/sensorSetting')

//profile
const ChangePassword = () => import('@/views/profile/changePassword')
const EditInfo = () => import('@/views/profile/editInfo')
const Alarm = () => import('@/views/profile/alarm')
const Message = () => import('@/views/profile/message')
const ProfileInfo = () => import('@/views/profile/profileInfo')

// setting
const Setting = () => import('@/views/settings/setting')

// report
const JointReport = () => import('@/views/report/jointReport')
const JointReportTotal = () => import('@/views/report/jointReportTotal')
const JointReportTotalUserDevice = () => import('@/views/report/jointReportTotalUserDevice')

//devices
const Devices = () => import('@/views/device/devices')
const Limits = () => import('@/views/device/limits')
const ValidLlimits = () => import('@/views/device/validLlimits')
const DevicePannel = () => import('@/views/device/devicePannel')





Vue.use(Router)

export default new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes() {
  return [
    // { path: "/", name: "Login", component: Login },
    // {
    //   path: '/',
    //   redirect: '/dashboard',
    //   name: 'Home',
    //   component: TheContainer,
    { path: "/", name: "Login", component: Login, beforeEnter: isLogin, },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'stopLocation',
          name: 'StopLocation',
          component: StopLocation
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            // {
            //   path: ':id',
            //   meta: {
            //     label: 'User Details'
            //   },
            //   name: 'User',
            //   component: User
            // }
          ]
        },
        {
          path: 'OrganizationStructure',
          name: 'OrganizationStructure',
          component: OrganizationStructure
        },
        {
          path: 'roles',
          name: 'Roles',
          component: Roles
        },

        {
          path: 'basicServices',
          name: 'BasicServices',
          component: BasicServices
        },

        {
          path: 'periodicServices',
          name: 'PeriodicServices',
          component: PeriodicServices
        },

        {
          path: 'costPerService',
          name: 'CostPerService',
          component: CostPerService
        },

        {
          path: 'layerClassify',
          name: 'layerClassify',
          component: LayerClassify
        },

        {
          path: 'layerPoint',
          name: 'layerPoint',
          component: LayerPoint
        },

        // {
        //   path: 'devices',
        //   redirect: '/devices/devices',
        //   name: 'Devices',
        //   component: {
        //     render(c) { return c('router-view') }
        //   },
        //   children: [
           
        //   ]
        // },
        {
          path: 'devices',
          name: 'Devices',
          component: Devices
        },
        {
          path: 'limits',
          name: 'Limits',
          component: Limits
        },
        {
          path: 'validLlimits',
          name: 'ValidLlimits',
          component: ValidLlimits
        },
        {
          path: 'devicePannel',
          name: 'DevicePannel',
          component: DevicePannel
        },
        {
          path: 'sensor',
          redirect: '/sensor/onlineChart',
          name: 'sensor',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'onlineChart',
              name: 'OnlineChart',
              component: OnlineChart
            },
            {
              path: 'sensorSetting',
              name: 'SensorSetting',
              component: SensorSetting
            },
          ]
        },
        {
          path: 'settings',
          redirect: '/settings/setting',
          name: 'seting',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'setting',
              name: 'Setting',
              component: Setting
            },
          ]
        },
        {
          path: 'report',
          redirect: '/report/jointReport',
          name: 'jointReport',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'jointReport',
              name: 'JointReport',
              component: JointReport
            },



          ]
        },
        {
          path: 'jointReportTotal',
          name: 'JointReportTotal',
          component: JointReportTotal
        },
        {
          path: 'jointReportTotalUserDevice',
          name: 'JointReportTotalUserDevice',
          component: JointReportTotalUserDevice
        },
        {
          path: 'profile',
          redirect: '/profile/changePassword',
          name: 'profile',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'changePassword',
              name: 'ChangePassword',
              component: ChangePassword
            },
            {
              path: 'editInfo',
              name: 'EditInfo',
              component: EditInfo
            },
            {
              path: 'alarm',
              name: 'Alarm',
              component: Alarm
            },
            {
              path: 'message',
              name: 'Message',
              component: Message
            },
            {
              path: 'profileInfo',
              name: 'ProfileInfo',
              component: ProfileInfo
            },


          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            },
            {
              path: 'multiSelectDualListBox',
              name: 'MultiSelectDualListBox',
              component: MultiSelectDualListBox
            }
          ]
        },
        {
          path: 'admin',
          name: 'Admin',
          component: Admin
        },

      ]
    },
    {
      path: 'carTracking',
      name: 'carTracking',
      component: CarTracking
    },

    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'registerUser',
          name: 'RegisterUser',
          component: RegisterUser,
          beforeEnter: isAuthenticated,
        },
        {
          path: 'forgetPassword',
          name: 'ForgetPassword',
          component: ForgetPassword
        },
        {
          path: 'leafLeft',
          name: 'LeafLeft',
          component: LeafLeft
        },
        {
          path: 'ChangePasswordPage',
          name: 'ChangePasswordPage',
          component: ChangePasswordPage
        }
      ]
    },

  ]
}

